import { TFunction } from 'i18next';

const isValidUsername = (url: string, t: TFunction, maxLength = 16) => {
  if (url.length > maxLength)
    return {
      isValid: false,
      message: t('bookings.setURLStep.urlLength'),
    };
  if (!/^[A-Za-z0-9_]*$/.test(url))
    return {
      isValid: false,
      message: t('bookings.setURLStep.invalidURL'),
    };
  return {
    isValid: true,
    message: '',
  };
};

export default isValidUsername;
